import {
  ADD_RELATION,
  ADD_RELATION_FAILURE,
  ADD_RELATION_SUCCESS,
  EDIT_RELATION,
  EDIT_RELATION_FAILURE,
  EDIT_RELATION_SUCCESS,
} from '../Actiontype';

export const AddRelation = data => ({
  payload: data,
  type: ADD_RELATION,
});
export const AddRelationSuccess = response => ({
  payload: response,
  type: ADD_RELATION_SUCCESS,
});
export const AddRelationFailure = response => ({
  payload: response,
  type: ADD_RELATION_FAILURE,
});
export const EditRelation = data => ({
  payload: data,
  type: EDIT_RELATION,
});
export const EditRelationSuccess = response => ({
  payload: response,
  type: EDIT_RELATION_SUCCESS,
});
export const EditRelationFailure = response => ({
  payload: response,
  type: EDIT_RELATION_FAILURE,
});
